import React from 'react';

export default function ImageBox(props) {
  return (
    <div className={"shadow-5in position-relative bg z-index br-100 d-flex align-items-center justify-content-center mx-auto " + props.boxwidth}>
        <img src={props.src} alt="" className="img-className"/>
    </div>
  )
}